module.exports = __webpack_public_path__ + "static/media/anprosem.ce1439ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anprosem.png
// module id = 80
// module chunks = 0